/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CustomerBranchOfficeControllerService } from './services/customer-branch-office-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CustomerBranchOfficeControllerService,
    ApiConfiguration
  ],
})
export class CustomersBranchofficeModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersBranchofficeModule> {
    return {
      ngModule: CustomersBranchofficeModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersBranchofficeModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersBranchofficeModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
